import { 
        API_URL, 
        API_PATHS,
        API_ENDS,
        USER_TOKEN_FIELD_NAME, 
        USER_TOKEN_INVALID_MESSAGE 
} from "../global/constants.js";

import userManager from './user-manager.js';

const HABITS_API_PATH = `${API_URL}/${API_PATHS.habits}`;
const HABIT_API_PATH = `${HABITS_API_PATH}/${API_PATHS.habit}`;
const BOARDS_API_PATH = `${API_URL}/${API_PATHS.boards}`;
const WORKOUTS_API_PATH = `${API_URL}/${API_PATHS.workouts}`;
const TODOS_API_PATH = `${API_URL}/${API_PATHS.todos}`;
const LOGIN_API_PATH = `${API_URL}/${API_PATHS.user}`;
const WLOGS_API_PATH = `${API_URL}/${API_PATHS.wLogs}`;
const NOTES_API_PATH = `${API_URL}/${API_PATHS.notes}`;
const TASKS_API_PATH = `${API_URL}/${API_PATHS.tasks}`;
const BUDGET_API_PATH = `${API_URL}/${API_PATHS.budget}`;

class APIManager {
    constructor() {
        if (!APIManager.instance) {
            this.userToken = '';

            if ( userManager.userLoggedIn() ) {
                this.setUserToken( userManager.getUserToken() ); 
            }
            this.bindFunctions();
        }
    }

     bindFunctions() {
        this.getBoardsData = this.getBoardsData.bind(this);
        this.getBoardsSettings = this.getBoardsSettings.bind(this);
        this.updateBoardVisibility = this.updateBoardVisibility.bind(this);
        this.orderBoards = this.orderBoards.bind(this);
        this.getBoardTypes = this.getBoardTypes.bind(this);
        this.editBoard = this.editBoard.bind(this);
        this.newBoard = this.newBoard.bind(this);

        // Habits
        this.getHabitsData = this.getHabitsData.bind(this);
        this.updateHabitStreak = this.updateHabitStreak.bind(this);
        this.newHabit = this.newHabit.bind(this);
        this.editHabit = this.editHabit.bind(this);
        this.deleteHabit = this.deleteHabit.bind(this);

        // Workouts
        this.getWorkoutsData = this.getWorkoutsData.bind(this);
        this.markWorkoutDone = this.markWorkoutDone.bind(this);
        this.restartWorkout = this.restartWorkout.bind(this);

        // ToDos
        this.getToDosData = this.getToDosData.bind(this);
        this.markToDoItemDone = this.markToDoItemDone.bind(this);
        this.newToDoItem = this.newToDoItem.bind(this);
        this.editToDo = this.editToDo.bind(this);
        this.deleteToDo = this.deleteToDo.bind(this);
        this.deleteToDoItem = this.deleteToDoItem.bind(this);
        this.orderToDos = this.orderToDos.bind(this);

        // WLogs
        this.getWLogsData = this.getWLogsData.bind(this);
        this.newWLog = this.newWLog.bind(this);

        //Notes
        this.getNotesData = this.getNotesData.bind(this);
        this.newNote = this.newNote.bind(this);
        this.editNote = this.editNote.bind(this);
        this.deleteNote = this.deleteNote.bind(this);

        // Tasks
        this.getTasks = this.getTasks.bind(this);
        this.getTasksWeek = this.getTasksWeek.bind(this);
        this.getTasksTargetWeek = this.getTasksTargetWeek.bind(this);
        this.getTasksTargetDay = this.getTasksTargetDay.bind(this);

        //Budget
        this.postBudgetData = this.postBudgetData.bind(this);
        this.getBudget = this.getBudget.bind(this);
        this.newSpending = this.newSpending.bind(this);
        this.deleteSpending = this.deleteSpending.bind(this);
        this.getLogBoardSettings = this.getLogBoardSettings.bind(this);
        this.editLogboardSettings = this.editLogboardSettings.bind(this);

        // User
        this.login = this.login.bind(this);
    }

    setUserToken(token='') {
        this.userToken = token;
    }

    generateJSONHeaders(includeToken=false) {
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };

        if ( includeToken && this.userToken ) {
            headers[USER_TOKEN_FIELD_NAME] = this.userToken;
        }

        return headers;
    }

    handleResponseFromServer(response={}, callback={}) {
        if ( response.success ) {
            callback(response);
        } else {
            if ( !response.success && response.message === USER_TOKEN_INVALID_MESSAGE ) {
                this.tokenError();
            }
        }
    }

    tokenError(response) {
        userManager.deleteUser();
        window.location.reload();
    }

    fetch(path='') {

    }    

    fetchData(callback={}) {
		fetch(HABITS_API_PATH, {
			method: 'GET',
			headers: this.generateJSONHeaders(true),
		})
		.then(response => response.json())
		.then((json) => {
            this.handleResponseFromServer(json, callback); 
        });
    }

    // TODO: Convert this so we can use it for both habit and boards
    // url instead of path, so the function calling it provides the url
    postData(url='', data=[], callback={}) {
        fetch(
            url,
            {
                method: 'POST',
                headers: this.generateJSONHeaders(true),
                body: JSON.stringify(data),
            }
        )
		.then(response => response.json())
		.then(
            (json) => {
               this.handleResponseFromServer(json, callback);
            },
            (error) => {
                console.log('APIManager | postData | error:', error);
                this.handleResponseFromServer(error, callback);
            }
        );
    }

    // 
    // Boards
    // 

    postBoardsData(path='', data=[], callback={}) {
        const url = `${BOARDS_API_PATH}/${path}`;
        this.postData(url, data, callback);
    }

    getBoardsData(data=[], callback={}) {
        this.postBoardsData('', data, callback);
    }

    getBoardsSettings(data=[], callback={}) {
        this.postBoardsData(API_ENDS.settings, data, callback);
    }

    orderBoards(data=[], callback={}) {
        this.postBoardsData(API_ENDS.order, data, callback);
    }

    updateBoardVisibility(data=[], callback={}) {
        const apiEnd = `${API_PATHS.board}/${API_ENDS.visibility}`;
        this.postBoardsData(apiEnd, data, callback);
    }

    getBoardTypes(data=[], callback={}) {
        this.postBoardsData(API_ENDS.types, data, callback);
    }

    editBoard(data=[], callback={}) {
        const apiEnd = `${API_PATHS.board}/${API_ENDS.edit}`;
        this.postBoardsData(apiEnd, data, callback)
    }

    newBoard(data=[], callback={}) {
        const apiEnd = `${API_PATHS.board}/${API_ENDS.new}`;
        this.postBoardsData(apiEnd, data, callback);
    }

    //
    //  Habits
    //
    
    postHabitsData(path='', data=[], callback={}) {
        const url = `${HABITS_API_PATH}/${path}`;
        this.postData(url, data, callback);
    }

    getHabitsData(data=[], callback={}) {
        this.postHabitsData('', data, callback);
    }

    updateHabitStreak(data=[], callback={}) {
        const id = data.habit_id ? data.habit_id : -1;
        this.postHabitsData(`${API_ENDS.updateStreak}`, data, callback);
    }

    postHabitData(path='', data=[], callback={}) {
        const url = `${HABIT_API_PATH}/${path}`;
        this.postData(url, data, callback);
    }

    newHabit(data=[], callback={}) {
        this.postHabitData(API_ENDS.new, data, callback);
    }

    editHabit(data=[], callback={}) {
        this.postHabitData(API_ENDS.edit, data, callback);
    }

    deleteHabit(data=[], callback={}) {
        this.postHabitData(API_ENDS.delete, data, callback);
    }

    // 
    // Workouts
    // 

    postWorkoutData(path='', data=[], callback={}) {
        const url = `${WORKOUTS_API_PATH}/${path}`;
        this.postData(url, data, callback);
    }

    getWorkoutsData(data=[], callback={}) {
        this.postWorkoutData('', data, callback);
    }

    markWorkoutDone(data=[], callback={}) {
        const id = data.workout_id ? data.workout_id : -1;
        this.postWorkoutData(`${API_ENDS.markWorkoutDone}`, data, callback);
    }

    restartWorkout(data=[], callback={}) {
        this.postWorkoutData(`${API_ENDS.restart}`, data, callback);
    }

    // 
    // ToDos
    // 

    postToDoData(path='', data=[], callback) {
        const url = `${TODOS_API_PATH}/${path}`;
        this.postData(url, data, callback);
    }

    getToDosData(data=[], callback={}) {
        this.postToDoData('', data, callback);
    }

    markToDoItemDone(data=[], callback={}) {
        const id = data.todo_item_id ? data.todo_item_id : -1;
        this.postToDoData(`${API_ENDS.markToDoItemDone}`, data, callback);
    }

    newToDoItem(data=[], callback={}) {
        this.postToDoData(`${API_ENDS.newToDoItem}`, data, callback);
    }

    createToDo(data=[], callback={}) {
        this.postToDoData(`${API_ENDS.new}`, data, callback);
    }

    editToDoItem(data=[], callback={}) {
        this.postToDoData(`${API_ENDS.editToDoItem}`, data, callback);
    }

    deleteToDoItem(data=[], callback={}) {
        this.postToDoData(`${API_ENDS.deleteToDoItem}`, data, callback);
    }

    editToDo(data=[], callback={}) {
        this.postToDoData(API_ENDS.edit, data, callback);
    }

    deleteToDo(data=[], callback={}) {
        this.postToDoData(API_ENDS.delete, data, callback);
    }

    orderToDos(data=[], callback={}) {
        this.postToDoData(API_ENDS.order, data, callback);
    }

    // 
    // WLogs
    // 

    postWLogsData(path='', data=[], callback={}) {
        const url = `${WLOGS_API_PATH}/${path}`;
        this.postData(url, data, callback);
    }

    getWLogsData(data=[], callback={}) {
        this.postWLogsData('', data, callback);
    }

    newWLog(data=[], callback={}) {
        this.postWLogsData(API_ENDS.new, data, callback);
    }

    // 
    // Notes
    // 

    postNotesData(path='', data=[], callback) {
        const url = `${NOTES_API_PATH}/${path}`;
        this.postData(url, data, callback);
    }

    getNotesData(data=[], callback={}) {
        this.postNotesData('', data, callback);
    }

    newNote(data=[], callback={}) {
        this.postNotesData(API_ENDS.new, data, callback);
    }

    editNote(data=[], callback={}) {
        this.postNotesData(API_ENDS.edit, data, callback);
    }

    deleteNote(data=[], callback={}) {
        this.postNotesData(API_ENDS.delete, data, callback);
    }

    // 
    // Tasks
    // 

    postTasksData(path='', data=[], callback) {
        const url = `${TASKS_API_PATH}/${path}`;
        this.postData(url, data, callback);
    }

    getTasks(data=[], callback={}) {
        this.postTasksData('', data, callback);
    }

    getTasksWeek(data=[], callback={}) {
        this.postTasksData(API_ENDS.week, data, callback);
    }

    getTasksTargetWeek(data=[], callback={}) {
        this.postTasksData(API_ENDS.targetWeek, data, callback);
    }

    getTasksTargetDay(data=[], callback={}) {
        this.postTasksData(API_ENDS.day, data, callback);
    }

    //
    // Budget
    //

    postBudgetData(path='', data=[], callback={}) {
        const url = `${BUDGET_API_PATH}/${path}`;
        this.postData(url, data, callback);
    }

    newSpending(data=[], callback={}) {
        this.postBudgetData(API_ENDS.new, data, callback);
    }

    deleteSpending(data=[], callback={}) {
        this.postBudgetData(API_ENDS.delete, data, callback);
    }

    getBudget(data=[], callback={}) {
        this.postBudgetData('', data, callback);
    }

    getLogBoardSettings(data=[], callback={}) {
        this.postBudgetData(API_ENDS.settings, data, callback);
    }

    editLogboardSettings(data=[], callback={}) {
        this.postBudgetData(`${API_ENDS.settings}/${API_ENDS.update}`, data, callback);
    }


    // 
    // User
    // 

    postLoginData(path='', data=[], callback={}) {
        fetch(`${LOGIN_API_PATH}/${path}/`, {
            method: 'POST',
            headers: this.generateJSONHeaders(),
            body: JSON.stringify(data),
        })
        .then(response => response.json())
        .then(json => callback(json));
    }

    login(data={}, callback={}) {
        this.postLoginData(`${API_ENDS.login}`, data, callback);
    }
}

const apiManager = new APIManager();

export default apiManager;